import type { AxiosInstance } from 'axios';
import type { AgendyAisOvmSeznamDto } from '../generated';

export const ovmQuery = async (
	axiosInstance: AxiosInstance,
	maAgendy?: boolean
): Promise<AgendyAisOvmSeznamDto> => {
	const { data } = await axiosInstance.get('/api/v1/ovm', {
		params: maAgendy ? { maAgendy } : {},
	});
	return data;
};
